import React, { useState } from 'react'
import { Box, Card, CardContent, CardMedia, CircularProgress, Grid, Typography } from '@mui/material'
import ImageNotSupportedIcon from "@mui/icons-material/ImageNotSupported";
import ImageViewModal from './ImageViewModal';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { useLazyDownloadFileQuery } from 'store/slices/apis/dmsSlice';
import { useDispatch } from 'react-redux';
import { closeSnackbar, openSnackbar } from 'store/slices/snackbar';

const styles = {
    height: 420,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    border: "1px solid #ddd",
    borderRadius: 2,
    bgcolor: "#f9fafb",
    color: "#6b7280",
    fontSize: 16,
    fontWeight: 500,
};
const ImagesViewer = ({ files, selectedFolderId }) => {
    const dispatch = useDispatch();
    const noFolder = !selectedFolderId;
    const noImages = selectedFolderId && files.length === 0;
    const showImages = selectedFolderId && files.length > 0;

    const [selectedFile, setSelectedFile] = useState(null);
    const [open, setOpen] = useState(false);
    const [isDownloading, setIsDownloading] = useState(null);
    const [triggerDownload, { isFetching: dowloadingLoader }] = useLazyDownloadFileQuery();

    const handleClose = () => {
        setOpen(false);
        setSelectedFile(null)
    }

    const handleClick = (file) => {
        setSelectedFile(file || null)
        setOpen(true)
    }

    const handleDownload = async (file, isPopupClose) => {
        try {
            setIsDownloading(file?.fileId)
            const blob = await triggerDownload({ fileId: file?.fileId }).unwrap();
            console.log("download blob", blob);

            const url = window.URL.createObjectURL(blob);

            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', file?.fileName || 'download');
            document.body.appendChild(link);

            link.click();
            link.parentNode.removeChild(link);
            window.URL.revokeObjectURL(url);
            openNotification("Downloaded Successfully", "success");
            //handleCloseMenu();
        } catch (error) {
            console.error("Download failed:", error);
            openNotification("Download Failed");
        } finally {
            setIsDownloading(null)
            if (isPopupClose) {
                handleClose()
            }
        }
    }

    const openNotification = (msg, type = "error", duration = 5000) => {
        dispatch(
            openSnackbar({
                open: true,
                message: msg,
                variant: 'alert',
                alert: {
                    color: type
                },
                close: false
            })
        );
        setTimeout(() => dispatch(closeSnackbar()), duration);
    };


    return (
        <>
            {noFolder && (
                <Box sx={styles}>
                    Please Select Folder
                </Box>
            )}

            {noImages && (
                <Box sx={styles}>
                    No Site Images Available
                </Box>
            )}

            {showImages && (
                <Box sx={{ height: 420, overflowY: "auto", p: 1 }}>
                    <Grid
                        container
                        spacing={2}
                        sx={{ height: "auto" }}
                    >
                        {files.map((item) => (
                            <Grid size={{ xs: 12, sm: 3 }} key={item?.id}>
                                <Card sx={{ height: "100%", borderRadius: 2 }}>
                                    {item?.contentType?.startsWith("image/") ? (
                                        <CardMedia
                                            component="img"
                                            sx={{ height: 180, objectFit: "cover", cursor: "pointer" }}
                                            image={item?.filePath || ""}
                                            alt={item?.fileName || "image"}
                                            onClick={() => handleClick(item)}
                                        />
                                    ) : (
                                        <Box
                                            sx={{
                                                height: 180,
                                                display: "flex",
                                                flexDirection: "column",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                bgcolor: "#f5f5f5",
                                                color: "#9ca3af",
                                                borderBottom: "1px solid #eee",
                                            }}
                                        >
                                            <ImageNotSupportedIcon sx={{ fontSize: 40, mb: 1 }} />
                                            <Typography variant="body2">
                                                No Preview Available
                                            </Typography>
                                        </Box>
                                    )}
                                    <CardContent sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 1 }}>
                                        {/* <Typography
                                            variant="body2"
                                            color="text.secondary"
                                            sx={{ fontSize: 14 }}
                                        >
                                            {item?.caption || "N.A"}
                                        </Typography> */}
                                        <Typography
                                            variant="h6"
                                            sx={{
                                                lineHeight: "110%", fontSize: 16,
                                                whiteSpace: "nowrap",
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                            }}
                                        >
                                            {item?.fileName || "N.A"}
                                        </Typography>
                                        {open === false && isDownloading === item.fileId ? <CircularProgress color='black' size={"15px"} /> : <FileDownloadIcon sx={{ cursor: "pointer" }} onClick={() => handleDownload(item)} />}
                                    </CardContent>
                                </Card>
                            </Grid>
                        ))}
                    </Grid>
                </Box>
            )}

            <ImageViewModal file={selectedFile} open={open} handleClose={handleClose} handleDownload={handleDownload} isLoading={isDownloading === selectedFile?.fileId} />
        </>
    )
}

export default ImagesViewer
